/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Единый энум со всеми кодами ошибок которые мы отправляем клиентам
 * Он используется пока не везде, но в будущем будем переходить на него, а не плодить энумы под каждый типа ошибки
 * @export
 * @enum {string}
 */
export var FxIdDomainEntitiesClientErrorCode;
(function (FxIdDomainEntitiesClientErrorCode) {
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["Unspecified"] = 0] = "Unspecified";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["SecurityTokenNotValidated"] = 1] = "SecurityTokenNotValidated";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["SettingsError"] = 2] = "SettingsError";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["MyGamesOauthNoCode"] = 10000] = "MyGamesOauthNoCode";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["MyGamesOauthNoState"] = 10001] = "MyGamesOauthNoState";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["MyGamesApiError"] = 10002] = "MyGamesApiError";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["ExternalIdTransferNotAllowed"] = 10009] = "ExternalIdTransferNotAllowed";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["ExternalIdTransferAwAccountAlreadyConnectedToAnotherSocial"] = 10010] = "ExternalIdTransferAwAccountAlreadyConnectedToAnotherSocial";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["ExternalIdTransferHelperSocialIdentifierAlreadyAttachedToAccount"] = 10013] = "ExternalIdTransferHelperSocialIdentifierAlreadyAttachedToAccount";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["ExternalIdTransferHelperAccountAlreadyHasSocialIdentifierOfThisType"] = 10014] = "ExternalIdTransferHelperAccountAlreadyHasSocialIdentifierOfThisType";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["ExternalIdTransferHelperFailedToTransfer"] = 10015] = "ExternalIdTransferHelperFailedToTransfer";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["TwitchTokenValidationFailed"] = 10016] = "TwitchTokenValidationFailed";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["SocialIdentifierAlreadyTaken"] = 10017] = "SocialIdentifierAlreadyTaken";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["TwitchAccountNotFound"] = 10018] = "TwitchAccountNotFound";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["TwitchDataWrong"] = 10019] = "TwitchDataWrong";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["TwitchCodeForTokenExchangeFailed"] = 10020] = "TwitchCodeForTokenExchangeFailed";
    FxIdDomainEntitiesClientErrorCode[FxIdDomainEntitiesClientErrorCode["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainEntitiesClientErrorCode || (FxIdDomainEntitiesClientErrorCode = {}));
export function instanceOfFxIdDomainEntitiesClientErrorCode(value) {
    for (const key in FxIdDomainEntitiesClientErrorCode) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainEntitiesClientErrorCode, key)) {
            if (FxIdDomainEntitiesClientErrorCode[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainEntitiesClientErrorCodeFromJSON(json) {
    return FxIdDomainEntitiesClientErrorCodeFromJSONTyped(json, false);
}
export function FxIdDomainEntitiesClientErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainEntitiesClientErrorCodeToJSON(value) {
    return value;
}
export function FxIdDomainEntitiesClientErrorCodeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainEntitiesClientErrorCode.js.map